import React from 'react'
import { Setters } from 'src/features/brands/gorilla/components'
import { OrderPageTemplate } from 'src/features/brands/components/OrderPageTemplate'
import { catcherReducer, initialStateCatcherMitt } from 'src/features/brands/gorilla/reducer/catcher'
import { State, PartialAction } from 'src/types'
import { BaseModelSelector } from 'src/features/brands/components/BaseModelSelector/BaseModelSelector'
import { gorillaBaseModel as models } from 'src/features/brands/gorilla/constants/baseModel'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/brands/gorilla/constants/actionType'

const GorillaCatcher: React.FC = () => {
  const [state, dispatch] = React.useReducer(catcherReducer, initialStateCatcherMitt) as [State, React.Dispatch<PartialAction>]
  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  return (
    <OrderPageTemplate
      breadcrumbTrail={'硬式 / ごりら印の野球道具 / 捕手用'}
      brand={'gorilla'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default GorillaCatcher
